import { css } from "../../../styled-system/css";

export const styles = {
  root: (isImageSize: boolean) =>
    css({
      maxWidth: !isImageSize ? "986px" : undefined,
      margin: "0 auto",
      color: "ink",
    }),

  title: () =>
    css({
      textAlign: "center",
      marginBottom: "baseUnit.mobile2",
      desktop: {
        marginBottom: "baseUnit.mobile3",
      },
    }),

  subtitle: () =>
    css({
      display: "block",
      textAlign: "center",
      maxWidth: "712px",
      marginTop: 0,
      marginX: "auto",
      marginBottom: "baseUnit.mobile3",
    }),

  itemsContainer: () =>
    css({
      display: "flex",
      flexWrap: "wrap",
      justifyContent: "center",
      desktop: {
        gap: "baseUnit.mobile3",
        flexWrap: "nowrap",
      },
    }),
};
